import React from 'react';

const SOCIAL_FIELDS = [
  { key: 'facebook_url', label: 'Facebook', iconClass: 'fab fa-facebook' },
  { key: 'instagram_url', label: 'Instagram', iconClass: 'fab fa-instagram' },
  { key: 'twitter_url', label: 'X (Twitter)', iconClass: 'fab fa-twitter' },
  { key: 'linkedin_url', label: 'LinkedIn', iconClass: 'fab fa-linkedin' },
];

function SocialCard({
  urls = {},
  editingField = null,
  hoverField = null,
  editValues = {},
  onEditValueChange = () => {},
  onHover = () => {},
  onStartEdit = () => {},
  onSave = () => {},
  onCancelEdit = () => {},
  submitting = false,
  error = '',
}) {
  return (
    <div className="cdp-card">
      <h2 className="cdp-card-title">Social</h2>

      {SOCIAL_FIELDS.map(({ key, label, iconClass }) => {
        const url = urls[key];
        const isEditing = editingField === key;

        return (
          <div
            key={key}
            className="cdp-side-row"
            onMouseEnter={() => onHover(key)}
            onMouseLeave={() => onHover(null)}
          >
            <span className="cdp-side-row-label">{label}</span>

            {isEditing ? (
              <input
                type="url"
                className="form-control form-control-sm"
                style={{ maxWidth: 170 }}
                autoFocus
                value={editValues[key] || ''}
                disabled={submitting}
                onChange={(e) => onEditValueChange(key, e.target.value)}
                onBlur={onSave}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    onSave();
                  }
                  if (e.key === 'Escape') {
                    e.preventDefault();
                    onCancelEdit();
                  }
                }}
              />
            ) : (
              <span className="cdp-side-row-value d-inline-flex align-items-center justify-content-end" style={{ gap: 8 }}>
                {url ? (
                  <a href={url} target="_blank" rel="noopener noreferrer" aria-label={`${label} profile`}>
                    <i className={iconClass} aria-hidden="true" />
                  </a>
                ) : (
                  '--'
                )}
                <button
                  type="button"
                  className="btn btn-link btn-sm p-0"
                  aria-label={`Edit ${label} URL`}
                  onClick={() => onStartEdit(key)}
                  onFocus={() => onHover(key)}
                  onBlur={() => onHover(null)}
                  style={{
                    opacity: hoverField === key ? 1 : 0,
                    pointerEvents: hoverField === key ? 'auto' : 'none',
                    transition: 'opacity 0.15s ease-in-out',
                  }}
                >
                  <i className="fal fa-pencil" aria-hidden="true" />
                </button>
              </span>
            )}
          </div>
        );
      })}

      {error && <div className="text-danger small mt-1">{error}</div>}
    </div>
  );
}

export default SocialCard;
